var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cookies",class:{ 'accepted': _vm.cookiesAcceptedLocal }},[_c('p',[_vm._v("\n        "+_vm._s(_vm._f("translate")('cookiesText'))+"\n        "),_c('router-link',{attrs:{"to":{ name: 'privacy-policy' }}},[_vm._v(_vm._s(_vm._f("translate")('cookiesLearnMore')))])],1),_vm._v(" "),_c('a',{staticClass:"button light-blue",on:{"click":function($event){return _vm.acceptCookies()}}},[_vm._v(_vm._s(_vm._f("translate")('acceptCookiesConfirmation')))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-14050be9","hasScoped":true,"buble":{"transforms":{}}}!./src/components/cookies/template.html
// module id = 597
// module chunks = 0